module.exports = __webpack_public_path__ + "img/emc2.434419d9.svg";